import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'

const urlModificar = 'https://datosprofes.cpem46.edu.ar/Backendphp/modificar_materia.php'

const ModificarRegistros = ({ materia, setSeccion, onGuardarExitoso}) => {
  const [formData, setFormData] = useState({
    tgs: '',
    cod_materia: '',
    cod_cargo: '',
    al: '',
    sr: '',
    sec: '',
    hs: '',
    asignatura: '',
    suple_a: ''
  })

  useEffect(() => {
    if (materia) {
      setFormData({
        tgs: materia.tgs ?? '',
        cod_materia: materia.cod_materia ?? '',
        cod_cargo: materia.cod_cargo ?? '',
        al: materia.al ?? '',
        sr: materia.sr ?? '',
        sec: materia.sec ?? '',
        hs: materia.hs ?? '',
        asignatura: materia.asignatura ?? '',
        suple_a: materia.suple_a ?? ''
      })
    }
  }, [materia])
  

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    modificarMateria(materia.id, formData, materia.docenteId) 
  }
  

  const modificarMateria = (materiaId, datosModificados, docenteId) => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: '¿Querés guardar los cambios en la materia?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, guardar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.put(urlModificar, {
          id: materiaId,
          docente_id: docenteId,
          ...datosModificados,
        })
        .then((res) => {
          Swal.fire({
            title: 'Éxito',
            text: 'Materia modificada correctamente',
            icon: 'success',
          })

          if (typeof onGuardarExitoso === 'function') {
            onGuardarExitoso()
          }

          setSeccion('') 
        })
        .catch((err) => {
          console.error(err)
          Swal.fire({
            title: 'Error',
            text: 'Hubo un error al modificar la materia',
            icon: 'error',
          })
        })
      }
    })         
  }
  
  const handleCancelar = () => {
    setSeccion('') 
  }
  

  return (
    <div className='form-register2'>
      <h1>Modificar Materia</h1>
      <form onSubmit={handleSubmit}>
        <div className='tabla-responsive'>
          <table className="tabla-asignacion">
            <thead>
              <tr>
                <th>TGS</th><th>Cod. Materia</th><th>Cod. Cargo</th><th>AL</th>
                <th>SR</th><th>SEC</th><th>HS</th><th>Asignatura</th><th>Suple a</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                {['tgs', 'cod_materia', 'cod_cargo', 'al', 'sr', 'sec', 'hs', 'asignatura', 'suple_a'].map((field) => (
                  <td key={field}>
                    <input
                      type="text"
                      name={field}
                      className="controls2"
                      value={formData[field]}
                      onChange={handleInputChange}
                    />
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>

        <div style={{ marginTop: '1rem' }}>
          <input className="botons" type="submit" value="Guardar Cambios" />
          <input className="botons" type="button" value="Cancelar" onClick={handleCancelar} />
        </div>
      </form>
    </div>
  )
}

export default ModificarRegistros
